export default "/_next/static/assets/DunbarTall-Bold_46aa0769d017be8f5d57925e1e7d9c1c.woff2";